<template>

  <div class="section d-flex">

    <div class="menu_section hidden-md-and-down"></div>
    <div class="container_section">

        <v-dialog
            v-model="loginPopup"
            width="500"
            persistent
            >
            <v-card outlined>

                <v-card-title class="pa-4 pb-0">
                    <h4>{{ $t("Verify your account") }}</h4>
                </v-card-title>
                
                <v-card-text class="pa-4 pb-0">

                    <v-divider class="mb-6"></v-divider>

                    <v-text-field
                        :label="$t('Password')"
                        outlined
                        v-model="passwordVerify"
                        type="password"
                        v-on:keyup.enter="verifyPassword();"
                    ></v-text-field>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions color="grey" class="pb-4 pt-4">

                    <v-btn :loading="loading.verifyPassword" depressed class="mx-2" color="primary" @click="verifyPassword();">{{ $t("Login") }}</v-btn>
                    <v-btn outlined class="mx-2" to="/dashboard">{{ $t("Cancel") }}</v-btn>

                </v-card-actions>

            </v-card>

        </v-dialog>

      <v-container>

        <v-breadcrumbs :items="breadcrumbs" class="pl-0 pb-0"></v-breadcrumbs>

        <h1 class="py-10">{{ $t("Profile") }}</h1>

        <v-card outlined class="mb-6">

            <v-card-title>
                <h4>{{ $t("Change e-mail") }}</h4>
            </v-card-title>
            
            <v-card-text class="pb-0">

                <v-divider class="mb-6"></v-divider>

                <v-text-field
                    label="E-Mail"
                    outlined
                    v-model="user.email"
                    v-on:keyup.enter="changeEmail();"
                ></v-text-field>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions color="grey" class="pb-4 pt-4">

                <v-btn :loading="loading.email" depressed class="mx-2" color="primary" @click="changeEmail();">{{ $t("Save") }}</v-btn>

            </v-card-actions>

        </v-card>

        <v-card outlined class="mb-6">

            <v-card-title>
                <h4>{{ $t("Change password") }}</h4>
            </v-card-title>
            
            <v-card-text class="pb-0">

                <v-divider class="mb-6"></v-divider>

                <v-text-field
                    :label="$t('New password')"
                    outlined
                    v-model="password"
                    type="password"
                    :rules="[rules.required, rules.min]"
                ></v-text-field>

                <v-text-field
                    :label="$t('Retype new password')"
                    outlined
                    v-model="passwordRetype"
                    password
                    type="password"
                    :rules="[rules.required, rules.min]"
                    v-on:keyup.enter="changePassword();"
                ></v-text-field>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions color="grey" class="pb-4 pt-4">

                <v-btn :loading="loading.password" depressed class="mx-2" color="primary" @click="changePassword();">{{ $t("Save") }}</v-btn>

            </v-card-actions>

        </v-card>

      </v-container>

    </div>
    
  </div>

</template>

<script>

import firebase from "firebase";
import { mapGetters } from "vuex";

// import { mapGetters } from "vuex";
export default {
  name: "Reporters",
  components: {
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
    user: "user/current"
    })
},
  data () {
    return {
    password: null,
    passwordRetype: null,
    loginPopup: true,
    passwordVerify: null,
    loading: {
        email: false,
        password: false,
        verifyPassword: false
    },
    rules: {
        required: value => !!value || this.$t('Required.'),
        min: v => v.length >= 8 || this.$t('Min 8 characters'),
    },
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: '/dashboard',
          exact: true
        },
        {
          text: 'Profile',
          disabled: true,
          exact: true
        },
      ]
    }
  },
  methods: {

      changeEmail(){
        
        let _this = this ; 
        var firebaseuser = firebase.auth().currentUser ;

        this.loading.email = true ;

        firebaseuser.updateEmail(this.user.email).then(function() {

            // Update successful.
            let snackbar = {
                color: 'green',
                show: true,
                text: _this.$t('Email changed')
            }

            _this.$store.commit("app/set_email", _this.user.email) ;
            _this.$store.commit("app/SET_SNACKBAR", snackbar) ;
            console.log('Email changed');

            _this.loading.email = false ;

        }).catch(function(error) {

            _this.$store.commit("app/SET_ERROR", error) ;

            // An error happened.
            console.log('error');
            console.log(error);

            _this.loading.email = false ;

        });

      },
      changePassword(){
        
        let _this = this ; 
        var firebaseuser = firebase.auth().currentUser ;

        this.loading.password = true ;

        if(!this.passwordRetype || !this.password || this.passwordRetype !== this.password){

            let snackbar = {
                color: 'red',
                show: true,
                text: _this.$t('The passwords you have entered do not match')
            }

            this.loading.password = false ;
            this.$store.commit("app/SET_SNACKBAR", snackbar) ;

        }

        firebaseuser.updatePassword(this.password).then(function() {

            // Update successful.
            let snackbar = {
                color: 'green',
                show: true,
                text: _this.$t('Password changed')
            }

            _this.$store.commit("app/SET_SNACKBAR", snackbar) ;
            console.log('Password changed');

            _this.loading.password = false ;

        }).catch(function(error) {

            _this.$store.commit("app/SET_ERROR", error) ;

            // An error happened.
            console.log('error');
            console.log(error);

            _this.loading.password = false ;

        });

      },
      verifyPassword(){

        let _this = this ; 
        var firebaseuser = firebase.auth() ;

        this.loading.verifyPassword = true ;

        // Prompt the user to re-provide their sign-in credentials

        firebaseuser.signInWithEmailAndPassword(this.user.email, this.passwordVerify).then(function() {

            // User re-authenticated.
            _this.loginPopup = false ;
            _this.loading.verifyPassword = false ;

        }).catch(function(error) {

            // An error happened.
            _this.$store.commit("app/SET_ERROR", error) ;

            // An error happened.
            console.log('error');
            console.log(error);

            _this.loading.verifyPassword = false ;

        });

      }

  },
  created() {

  }

};
</script>
